module.exports = __webpack_public_path__ + "static/media/agec.95b3c84f.jpg";